import React from 'react';
import { motion } from 'framer-motion';
import styles from './MetaTag.module.css';

interface MetaTagProps {
  label: string;
  color?: string;
}

const MetaTag: React.FC<MetaTagProps> = ({ label, color = '#2196f3' }) => {
  return (
    <motion.span
      className={styles.tag}
      style={{ backgroundColor: color }}
      initial={{ maxWidth: 0, opacity: 0, paddingLeft: 0, paddingRight: 0 }}
      animate={{ maxWidth: '200px', opacity: 1, paddingLeft: 8, paddingRight: 8 }}
      exit={{ maxWidth: 0, opacity: 0, paddingLeft: 0, paddingRight: 0 }}
      transition={{ 
        duration: 0.3,
        ease: 'easeIn'
      }}
    >
      {label}
    </motion.span>
  );
};

export default MetaTag; 